import { render, staticRenderFns } from "./TranzilaSupplier.vue?vue&type=template&id=35c4e6ef&"
import script from "./TranzilaSupplier.vue?vue&type=script&lang=ts&"
export * from "./TranzilaSupplier.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports